import { useState } from "react";
import AnimatedScroll from "../AnimatedScroll/AnimatedScroll";

/**
 * Remplacez FORM_ENDPOINT via .env : REACT_APP_FORM_ENDPOINT=https://formspree.io/f/xxxxxx
 */
const FORM_ENDPOINT = process.env.REACT_APP_FORM_ENDPOINT;
const CONTACT_FORM_ENABLED =
  String(process.env.REACT_APP_CONTACT_FORM_ENABLED || "true").toLowerCase() ===
  "true";

console.log("REACT_APP_FORM_ENDPOINT =", process.env.REACT_APP_FORM_ENDPOINT);
console.log(
  "CONTACT_FORM_ENABLED =",
  process.env.REACT_APP_CONTACT_FORM_ENABLED
);

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  if (!CONTACT_FORM_ENABLED) return null;

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validate = (data) => {
    const e = {};
    if (!data.name || data.name.trim().length < 2) {
      e.name = "Veuillez renseigner un nom valide.";
    }
    if (!data.email || !validateEmail(data.email.trim())) {
      e.email = "Veuillez renseigner une adresse email valide.";
    }
    if (!data.message || data.message.trim().length < 5) {
      e.message = "Veuillez écrire un message (au moins 5 caractères).";
    }
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
    setErrorMessage("");
    setSuccessMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    // Guard si endpoint non configuré
    if (!FORM_ENDPOINT) {
      setErrorMessage(
        "Le formulaire n'est pas configuré (variable d'environnement REACT_APP_FORM_ENDPOINT manquante)."
      );
      return;
    }

    const fieldErrors = validate(formData);
    if (Object.keys(fieldErrors).length > 0) {
      setErrors(fieldErrors);
      setErrorMessage("Veuillez corriger les champs en erreur.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setSuccessMessage("Votre message a été envoyé avec succès !");
        setFormData({ name: "", email: "", message: "" });
        setErrors({});
      } else {
        const data = await res.json().catch(() => ({}));
        setErrorMessage(
          data?.error || "Une erreur s'est produite lors de l'envoi."
        );
      }
    } catch (err) {
      console.error("Erreur lors de l'envoi du message:", err);
      setErrorMessage("Une erreur réseau s'est produite. Réessayez plus tard.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="single-contact-box">
      <div className="contact-form">
        <form onSubmit={handleSubmit} noValidate>
          <div className="row">
            <div className="col-sm-6 col-xs-12">
              <div className="form-group">
                <AnimatedScroll>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nom*"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    aria-invalid={!!errors.name}
                  />
                  {errors.name && (
                    <div
                      className="field-error"
                      role="alert"
                      style={{
                        color: "#ff6b6b",
                        marginTop: "6px",
                        fontSize: "0.9rem",
                      }}
                    >
                      {errors.name}
                    </div>
                  )}
                </AnimatedScroll>
              </div>
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="form-group">
                <AnimatedScroll>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email*"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    aria-invalid={!!errors.email}
                  />
                  {errors.email && (
                    <div
                      className="field-error"
                      role="alert"
                      style={{
                        color: "#ff6b6b",
                        marginTop: "6px",
                        fontSize: "0.9rem",
                      }}
                    >
                      {errors.email}
                    </div>
                  )}
                </AnimatedScroll>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <AnimatedScroll>
                  <textarea
                    className="form-control"
                    rows="8"
                    placeholder="Message*"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    aria-invalid={!!errors.message}
                  ></textarea>
                  {errors.message && (
                    <div
                      className="field-error"
                      role="alert"
                      style={{
                        color: "#ff6b6b",
                        marginTop: "6px",
                        fontSize: "0.9rem",
                      }}
                    >
                      {errors.message}
                    </div>
                  )}
                </AnimatedScroll>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <AnimatedScroll>
                <div className="single-contact-btn">
                  <button
                    type="submit"
                    className="contact-btn"
                    disabled={loading || !FORM_ENDPOINT}
                    aria-busy={loading}
                    title={
                      !FORM_ENDPOINT
                        ? "Formulaire désactivé : REACT_APP_FORM_ENDPOINT manquant"
                        : ""
                    }
                  >
                    {loading ? "Envoi..." : "Envoyez"}
                  </button>
                </div>
              </AnimatedScroll>
            </div>
          </div>

          {successMessage && (
            <div className="success-message" role="status">
              <p className="message-send">{successMessage}</p>
            </div>
          )}

          {errorMessage && (
            <div
              className="success-message"
              role="alert"
              style={{
                background: "rgba(255,80,80,0.12)",
                borderColor: "rgba(255,80,80,0.18)",
              }}
            >
              <p className="message-send">{errorMessage}</p>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
